import React from 'react';
import { useParams } from 'react-router-dom';
import { useAppConfig } from '@/modules/config';
import { topicGardenEnabled } from '@/conditional_feature/topic_garden_enabled';
import { TopicReadPage } from '@/modules/topic_garden';
import TopicView from './TopicView';

/**
 * View-mode route for a topic.
 *
 * With the garden flag on, the read experience is the shared component-driven
 * view for ANY type, so we commit to it immediately — before the topic's type is
 * known — and keep a single view mounted for the whole read lifecycle, including
 * the pre-load / by-invitation-only masked phase. This avoids swapping the
 * top-level component mid-flow (legacy `TopicView` while masked, then the
 * component-driven view once the topic loads); such a swap unmounts a view while
 * an Ionic interstitial is still dismissing and strands its backdrop / action
 * sheet over the unlocked topic (#524).
 *
 * With the flag off (the default), this renders exactly
 * `<TopicView initialMode="view" />` — the legacy path, byte for byte.
 */
const ReadTopicGate: React.FC = () => {
  const { topicId } = useParams<{ topicId: string }>();
  const { features } = useAppConfig();

  if (topicGardenEnabled(features)) {
    return <TopicReadPage topicId={topicId} />;
  }

  return <TopicView initialMode="view" topicId={topicId} />;
};

export default ReadTopicGate;
